import { AppColor, AppColorContainer } from "./AppColorContainer";

/** This is the color container light mode implementation used by getAppColorContainer interface implementation. */
export class LightModeAppColorContainer implements AppColorContainer {

  darkLabelColor: AppColor = { value : "#212121" };

  mediumLabelColor: AppColor = { value : "#303030" };

  lightLabelColor: AppColor = { value : "#6e6e6e" };

  timestampLabelColor: AppColor = { value: "#11100f" };

  linkColor: AppColor = { value: "#2b579a" };

  defaultBackgroundColor: AppColor = { value: "#edebe9" };

  lightBackgroundColor: AppColor = { value: "#faf9f8" };

  darkBackgroundColor: AppColor = { value: "#cccccc" };

  primaryWidgetColor: AppColor = { value: "#2b579a" };

  primaryWidgetColorOnHover: AppColor = { value: "#245BBE" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetColorOnHover: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColor: AppColor = { value: "#323130" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#323130" };

  secondaryWidgetBorderColor: AppColor = { value: "#BEBBB8" };

  blackColor: AppColor = { value: "#000000" };

  whiteColor: AppColor = { value: "#ffffff" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#605e5c" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#2E6AC5" };

  bulletGray: AppColor = { value: "#D2D0CE" };

  progressBackground: AppColor = { value: "#D5D4D2" };

  popupBackground: AppColor = { value: "#2B579A" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#605D5A" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#33312D" };
}